export default __webpack_public_path__ + "static/article-wedding-on-a-budget-636dafe85c14e49d6c259a81810b6ece.jpg";